import { useEffect, useState } from "react";

/**
 * Hook para detectar cambios en media queries
 * @param query - Media query string (ej: "(max-width: 768px)")
 * @returns boolean indicando si la query coincide
 *
 * @example
 * const isMobile = useMediaQuery("(max-width: 768px)");
 * const isTablet = useMediaQuery("(min-width: 769px) and (max-width: 1024px)");
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => {
    // SSR-safe: retorna false durante SSR
    if (typeof window === "undefined") return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    // SSR guard
    if (typeof window === "undefined") return;

    const mediaQuery = window.matchMedia(query);

    // Handler para cambios
    const handleChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    // Listener moderno (mejor performance que resize)
    mediaQuery.addEventListener("change", handleChange);

    // Cleanup
    return () => mediaQuery.removeEventListener("change", handleChange);
  }, [query]); // Solo re-ejecuta si cambia la query

  return matches;
}
